import {
  AUTH_TOKEN,
  REFRESH_TOKEN,
  EXPIRE_TIME,
  FIREBASE_TOKEN,
  USER_ROLES,
} from "constants/AuthConstant";
import { isString } from "lodash";

export const setAuthenData = (data) => {
  const token = data.tokenData.token;
  localStorage.setItem(AUTH_TOKEN, token);
  const refreshToken = data.tokenData.refreshToken;
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  const expiredTime = data.tokenData.expires;
  localStorage.setItem(EXPIRE_TIME, expiredTime);
  const firebaseToken = data.firebaseToken;
  localStorage.setItem(FIREBASE_TOKEN, firebaseToken);
  localStorage.setItem(USER_ROLES, data.userRoles);
};

export const getExtension = (fileName, indexOf = 0) => {
  let fileExt = "";
  const dotLastIdx = fileName.lastIndexOf(".");
  if (dotLastIdx >= 0) fileExt = fileName.substring(dotLastIdx + indexOf);

  return fileExt;
};
export const makeRandomId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
export const getNameWithoutExtension = (fileName) => {
  return fileName.substr(0, fileName.lastIndexOf("."));
};

export const formatInputMoney = (n) => {
  if (n <= 0) return 0;
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatMoney = (n) => {
  const price = isString(n) ? +n : n;
  if (price < 0) return 0;
  return price?.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
  });
};

export function ts(time, dayOffset) {
  const [hh, mm] = time.split(":").map(Number);
  const base = new Date("2026-05-07T00:00:00+07:00").getTime();
  return base - dayOffset * 86400000 + hh * 3600000 + mm * 60000;
}

export function relativeTime(dateInput) {
  // 1. Chuyển đổi mọi kiểu dữ liệu đầu vào (Date object, string, hoặc timestamp) thành Epoch ms
  const tsMs = new Date(dateInput).getTime();

  // Kiểm tra nếu ngày tháng truyền vào không hợp lệ (NaN)
  if (isNaN(tsMs)) return "";

  // 2. Lấy thời gian hiện tại tại thời điểm gọi hàm
  const now = Date.now();
  const diff = now - tsMs;

  // Nếu thời gian truyền vào ở tương lai hoặc vừa mới xảy ra (< 1 giây)
  if (diff < 1000) return "vừa xong";

  // 3. Tính toán các đơn vị thời gian
  const m = Math.floor(diff / 60000);
  if (m < 1) return "vừa xong";
  if (m < 60) return `${m} phút trước`;

  const h = Math.floor(m / 60);
  if (h < 24) return `${h} giờ trước`;

  const d = Math.floor(h / 24);
  if (d < 30) return `${d} ngày trước`;

  // Thêm điều kiện cho tháng và năm nếu khoảng thời gian quá dài (Tùy chọn)
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo} tháng trước`;

  const y = Math.floor(mo / 12);
  return `${y} năm trước`;
}

export function CalcBreakEvenKm(zonePrice, distanceRate) {
  if (!zonePrice || !distanceRate?.pricePerKm) return null;

  const km =
    (zonePrice - (distanceRate.openingFare || 0)) / distanceRate.pricePerKm;
  if (!Number.isFinite(km) || km <= 0) return null;

  return Math.round(km * 10) / 10;
}
